import React from "react";
import CircularProgressBar from "./CircularProgressBar";

export default function CircularProgress({ percent, title, attackTittle, type }) {
  // console.log(percent);
  const getTagBasedOnPer = (percent) => {
    return percent >= 0 && percent <= 25
      ? "Critical"
      : percent > 25 && percent <= 50
        ? "High"
        : percent > 50 && percent <= 75
          ? "Medium"
          : percent > 75 && percent <= 100
            ? "Low"
            : "-"
  }
  return (
    <>
      {(attackTittle) ? (
        <div className="attack-box">
          <h2 className="attack-tittle">{attackTittle}</h2>
          <CircularProgressBar percent={percent} />
        </div>
      ) : (
        <div className="box-Security-control">
          {/* <div className="fit-bottom">
            <h2>{title}</h2>
          </div> */}
          <div className="progress-part">
            <CircularProgressBar percent={percent} type={type} />
          </div>
          {title && <div style={{ width: '100%' }}>
            <p><span className={`tagClass ${getTagBasedOnPer(percent)}`}>
              {getTagBasedOnPer(percent)}
            </span></p>
          </div>}
        </div>
      )}

    </>
  );
}
